
import Component from "vue-class-component";
import Vue from "vue";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import { getModule } from "vuex-module-decorators";
import notifications from "../../lib/notifications";
import { ImportManifestResponse, ManifestImportErrorResource } from "../../models/api/barcodeSystem/manifests/importManifests";
import Select from "@/components/form/Select.vue";
import { formatDate, formatBool } from "../../utils";

const manifestModuleState = getModule(ManifestModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component({
  components: {
    Select,
  },
})
export default class ImportManifests extends Vue {
  uploading: boolean = false;
  saving: boolean = false;
  loading: boolean = true;
  file: any = null;
  response: ImportManifestResponse = null;
  showWarnings: boolean = false;

  async created() {
  }

  goBack() {
    this.$router.back();
  }

  async uploadFile() {
    this.uploading = true;

    try {
      this.response = await manifestModuleState.importManifests({
        file: this.file,
        facilityCode: barcodeSystemModuleState.currentFacilityCode
      });

      if(this.response.success && (!this.response.manifests || this.response.manifests.length == 0 ))
      {
        notifications.error("Manifest Import", "No manifests found in import file.");
        this.response = null;
      }
    } catch (ex) {
      notifications.error("Manifest Import", "Failed to import manifests", ex);
    } finally {  
      this.file = null;     
    }

    this.uploading = false;
  }

  resetImport() {
    this.response = null;
    this.file = null;     
  }

  formatDate(date: Date): string {
    return formatDate(date, "YYYY-MM-DD");
  }

  formatZip3s(zip3s: Array<string>): string {
    if(zip3s)
      return zip3s.join(",");
    return ""
  }

  formatBool(bool: boolean): string {
    return formatBool(bool);
  }

  viewManifest(manifest)
  {
    manifestModuleState.viewManifestShortcutAction({selectedItems: [manifest]})
  }

  get importHasErrors(): boolean {
    return this.response && this.response.errors && this.response.errors.length > 0;
  }

  set importHasErrors(val: boolean) {
    if (!val) {
      this.response = null;
    }
  }

  get importHasWarnings(): boolean {
    return this.response && this.response.warnings && this.response.warnings.length > 0;
  }

  get importSuccess(): boolean {
    return this.response && this.response.success && this.response.manifests.length > 0;
  }

  get importCanBeSaved(): boolean {
    return this.response && !this.importHasErrors;
  }

  hideImportErrorModal() {
    this.$bvModal.hide("importErrorModal");
  }  
  
  hideImportWarningModal() {
    this.$bvModal.hide("importWarningModal");
  }

  hideSaveErrorModal() {
    this.$bvModal.hide("saveErrorModal");
  }

  viewWarnings() {
    this.showWarnings = true;
  }

  get canSubmitPreview() {
    return barcodeSystemModuleState.currentFacilityCode && this.file;
  }

  manifestString(manifest) {
    return `${manifest.manifestName} ${formatDate(manifest.deliveryDate)}`
  }

  downloadErrorCSVData(errors: ManifestImportErrorResource[]) {
    var csv = "location,message\n";
    errors.forEach((error) => {
      csv += '"' + error.location.replace('"', '""') + '","' + error.message.replace('"', '""') + '"\n';
    });
 
    const anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    anchor.target = '_blank';
    anchor.download = 'export-exceptions.csv';
    anchor.click();
  } 
}
